import { createContext } from 'react';
export var personalBeautyStoreContext = /*#__PURE__*/createContext({
  pbsData: null,
  inviteFriendData: null,
  storeInfo: null,
  tooltipWasShown: false,
  setTooltipWasShown: function setTooltipWasShown() {}
});